const EaselIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 4H18.5V1H20V4H23V5.5H20V18.5H23V20H20V23H18.5V20H5.5V23H4V20H1V18.5H4V5.5H1V4H4V1H5.5V4ZM5.5 18.5H18.5V5.5H5.5V18.5Z" fill="white"/>
    </svg>`;
export default EaselIcon;
